import { useEffect, useRef, useState } from 'react'
import { Col, Row, } from 'react-bootstrap';
import { FaDownload, } from "react-icons/fa";
import { useSelector } from 'react-redux';
import '../../../../Styles/Ht.css';
import { config } from '../../../CommonUtilities/CommonUrl/CommonUrls';
import { CommonAxiosGet } from '../../../CommonUtilities/CommonAxios/CommonAxios';
import { useReactToPrint } from 'react-to-print';
import { CommonPageHeading } from '../../../CommonUtilities/CommonHeading/CommonPageHeading';
import moment from 'moment';
import { CONTEXT_NAME } from '../../../CommonUtilities/Validations/RegularExpAndVar';
export const inst = [
    { label: "Check that your name and registration number are correct on the hall ticket.", },
    { label: "Candidates will be allowed inside the test centre 90 minutes before the commencement of the examination. No candidate will be allowed after 9:30 A.M (Morning Session) / 2.30 P.M (Afternoon Session). Candidates are advised to check the location of examination centre in advance and also reach the examination centre early to avoid last minute rush.", },
    { label: "The hall ticket must be presented for verification along with at least one original, valid photo identification card. If a candidate without a photograph on the hall ticket must bring two passport-size photographs.", },
    { label: "The management is not responsible for the loss of any valuable devices or personal belongings left outside the examination hall.", },
    { label: "Candidates are requested to cooperate with security staff during frisking before entering the exam hall.", },
    { label: "Candidates are strictly prohibited from carrying electronic gadgets such as mobile phones, programmable calculators, tablets, pen drives, iPads, Bluetooth devices, pagers, writing pads, calculators, wallets, wristwatches, handbags, etc., into the examination hall. Any violation will result in disqualification.", },
    { label: "Frequent visits to the toilet are not permitted. Candidates should use the facility only in cases of extreme necessity. Any candidate found engaging in discussions or malpractice near the toilets, corridors, or other areas under the pretext of using the toilet will be disqualified.", },
    { label: "Candidates are not allowed to leave the examination hall until the examination is completed. If a candidate leaves the hall during the examination, they will be disqualified. In the event of a computer system issue, candidates must wait quietly without interacting with others until the issue is resolved. Any violation will lead to disqualification.", },
    { label: "Please inform the invigilator immediately in case of any technical issues during the examination.", },
    { label: "Hall tickets are generated based on the information submitted in the application, and based on the eligibility conditions given in the notification. If any information submitted is false/incorrect, the candidate will be liable for rejection at any point of time in the selection process, apart from initiating action on the candidates as per rules.", },
    { label: "Candidates are expected to behave in orderly and disciplined manner while writing the examination. In case of impersonation/ disorder /rowdy behaviour during examination in and around the examination centre, necessary FIR for the incident will be lodged with concerned police station apart from disqualifying the candidature. The Departmental Officer concerned is duly authorized to take spot action in such cases.", },
    { label: "Admission to the examination is provisional subject to the confirmation/satisfaction of conditions laid down in Recruitment Notification and also subject to satisfying the eligibility criteria and verification of required certificates at a later stage. Admission / Appearing to the Examination does not confer ipso facto right for recruitment / selection.", },
    { label: 'Only future scheduled exams are shown on this hall ticket.' }
];
export const Afterprint = () => (
    <div className="logo-hall">
        <img src="img/APGOV.png" className="img-fluid" alt="logo" />
        <div className='hallticket-title px-4'>
            <h3 style={{ color: 'green' }}>
               ANDHRA PRADESH TEACHER ELIGIBILITY TEST - 2025
            </h3>
            <h5><b>HALL TICKET</b></h5>
        </div>
    </div>
);
export default function HallTicketFinal() {
    const loginreducer = useSelector((state) => state.reducers.loginreducer.loginDetails.loginData);
    const [showhstatus, sethstatus] = useState(true)
    const [postData, setPostData] = useState([]);
    const getDataFunction = async () => {
        const url = `${config.url.CONTEXT_READ_URL}hallticket-details`;
        try {
            const response = await CommonAxiosGet(url);
            if (response?.data?.status === true) {
                const posts = response?.data?.data || [];
                setPostData(posts);
                sethstatus(true);
            } else {
                sethstatus(false)
                setPostData([]);}
        } catch (error) {
            console.error("Error in getDataFunction", error);
            setPostData([]);
        }
    };
    const HtPdfView = () => {
        getDataFunction();
    };
    const componentRef = useRef(); const handlePrint = useReactToPrint({
        content: () => componentRef.current,
        documentTitle: `${postData[0]?.candidate_id}_HallTicket`,
        pageStyle: `
           @media print {
           .person-details {
        margin-top: 5px;
        display: flex;
        align-items: flex-start;
        /* for multiline alignment */
        margin-bottom: 8px;
    }

    .label {
        width: 150px;
        /* fixed width to align colons */
        margin: 0;
        font-weight: bold;
    }

    .value {
        display: flex;
        gap: 6px;
        flex: 1;
        margin: 0;
    }

    .colon {
        min-width: 10px;
    }} `
    });
    useEffect(() => {
        if (showhstatus && postData?.length > 0) {
            handlePrint();
        }
    }, [showhstatus, postData]);

    const PrintContent = () => {
        return (
            <div className="mt-2" ref={componentRef}>
                <Row className="mt-1">
                    <Col md={12} sm={12}>
                        <center>
                            <div className="print-wrapper border-secondary total-page-border" style={{
                                padding: '10px', width: "100%",
                                backgroundColor: 'white',
                                boxSizing: 'border-box',
                            }}>
                                <div className="table-responsive align-center" id="hallticket" style={{ fontFamily: '"Times New Roman", Times, serif', fontSize: '18px', }}>
                                    <table className="table table-bordered hallticket-table-top" role="presentation">
                                        <thead className='border border-secondary' style={{ textAlign: 'center', justifyContent: 'center' }} ><tr>
                                            <td colSpan={4}>
                                                <Afterprint />
                                            </td></tr></thead>
                                        <tbody className='border border-secondary' style={{ textAlign: "left", fontSize: "15px", background: '#fff7f9', textTransform: 'uppercase' }}>
                                            <tr>
                                                <td style={{ width: '15%' }}>HALL TICKET NO.</td>
                                                <th colSpan={2} style={{ width: '20%', textAlign: 'left' }} >{postData[0]?.candidate_id}</th>
                                                <td rowSpan={7} className="border border-secondary photo-cell" style={{ width: '30%' }}>
                                                    <img
                                                        src={postData[0]?.img_path ? config.url.FILE_DOWNLOAD_URL + postData[0]?.img_path : '#'}
                                                        id="imgid"
                                                        alt="studentphoto"
                                                        className='hallticket-person-img'
                                                    />
                                                </td>
                                            </tr>
                                            <tr><td>CANDIDATE NAME </td><th colSpan={2} className='candidate-name'>{postData[0]?.applicant_name}</th> </tr>
                                            <tr> <td>FATHER NAME</td>
                                                <th colSpan={2}>{postData[0]?.father_name}</th>
                                            </tr>  <tr>
                                                <td>DATE OF BIRTH</td>
                                                <th colSpan={2}>{postData[0]?.dob_char}</th>
                                            </tr>  <tr>
                                                <td>GENDER</td>
                                                <th colSpan={2}>{postData[0]?.gender}</th>
                                            </tr>  <tr>
                                                <td>COMMUNITY</td>
                                                <th colSpan={2}>{postData[0]?.caste}</th>
                                            </tr>
                                            <tr>
                                                <td>CANDIDATE DISTRICT</td>
                                                <th colSpan={2}>{postData[0]?.dist_name}</th>
                                            </tr>
                                            <tr>
                                                <td>PH CATEGORY</td>
                                                <th>{postData[0]?.is_ph ? <>YES</> : 'NO'}</th>
                                                <td>EX-SERVICEMEN</td>
                                                <th>{postData[0]?.is_ex_service_men ? 'YES' : 'NO'}</th>
                                            </tr>
                                            <tr>
                                                <td>CANDIDATE ADDRESS</td>
                                                <th colSpan={3}> {postData[0]?.door_no},{postData[0]?.village_name},{postData[0]?.mandal_name}, {postData[0]?.dist_name}-{postData[0]?.pin_code}</th>
                                            </tr>
                                        </tbody>

                                    </table>
                                </div>
                                <div className="table-responsive align-center">
                                    <table className="table table-bordered hallticket-table-top1" style={{ textTransform: 'uppercase' }} role="presentation">
                                        <thead style={{ background: '#e9ecef', fontSize: '18px' }}>
                                            <tr>
                                                <th className='post-size'>Post & Exam Date - Time</th>
                                                <th className='center-size'>Examination Center Name & Address</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {postData.map((val, i) => (
                                                <tr key={i}>
                                                    <td>
                                                        <b style={{ color: 'brown' }}>{val?.post_name}</b>
                                                        <br />
                                                        <b>{val?.exam_date_char} {val?.exam_time}</b>
                                                    </td>
                                                    <td style={{ fontSize: '12px' }}>
                                                        {val?.exam_center_name},<br />
                                                        {val?.exam_center_address},
                                                    </td>
                                                </tr>
                                            ))}
                                            <tr className='signature-row'>
                                                <td colSpan={2}>
                                                    <div className='d-flex align-items-center justify-content-end'>
                                                        <div className='hall-ticket-sign text-center'>
                                                            <img src="../img/original_sign.jpeg" className="img-fluid mb-2" alt="sign" />
                                                            <p style={{ padding: '0px 0px 2px 4px' }}>Convenor of {CONTEXT_NAME}</p>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div className="table-responsive align-center">
                                    <table className="table instruction-points" role="presentation">
                                        <thead>
                                            <tr className='text-center'>
                                                <td colSpan={2} className='p-0'>
                                                    <div className='inter-main-head'>
                                                        <h5 style={{ textAlign: 'center', fontWeight: 'bold' }}>
                                                            GUIDELINES AND INSTRUCTIONS TO CANDIDATES
                                                        </h5>
                                                    </div>
                                                </td>
                                            </tr>
                                        </thead>
                                        <tbody className='border'>
                                            {inst?.map((item, index) => (
                                                <tr key={index}>
                                                    <td style={{ fontSize: '18px', paddingLeft: '20px' }}>{index + 1}) </td>
                                                    <td style={{ fontSize: '18px', paddingRight: '20px' }} className='text-left'>
                                                        {item.label}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div></center>
                    </Col>
                </Row>
                <div style={{ textAlign: "right", fontSize: "14px", marginTop: "10px", fontWeight: "500" }} className="printtime">
                 Downloaded on : {moment().format("DD/MM/YYYY hh:mm:ss A")}
                </div>
            </div>
        );
    };
    return (
        <div className="p-0 mt-4" >
            <CommonPageHeading heading='Download Hall Ticket' />
            {showhstatus === true && (<Row className='mt-4'><Col md={2} ></Col>
                <Col md={8} className='text-error text-center mt-4'><h5 className='pt-4' style={{ color: 'black' }}>
                    Dear <span style={{ color: 'brown' }}>{loginreducer?.applicant_name}  </span>, <br /><br />
                    Click Here &nbsp;
                    <FaDownload color='green' size="25px" onClick={() => { HtPdfView() }} />&nbsp;
                    to download the hallticket.</h5>
                </Col><Col md={2} ></Col> <div className='print-hall-hide'>
                    <PrintContent />
                </div></Row>)}
            {showhstatus === false && (<div className='alert alert-warning'>No Data Found / Your Exams are already completed</div>)}
        </div>
        )
}
